export enum MediaBreakpoint {
    Mobile = 360,
    Desktop = 1280
}

export const MediaObserverRules = {
    Mobile: `(min-width: ${MediaBreakpoint.Mobile}px) and (max-width: ${MediaBreakpoint.Desktop - 1}px)`,
    Desktop: `(min-width: ${MediaBreakpoint.Desktop}px)`
};
